import Record from '../Record'

export default class OpeningHours extends Record {

	constructor (data) {
		super(data)

		// Normál nyitvatartások
		if (!Array.isArray(data.regular_days)) {
			// Ha még nincs adat, akkor a hét napjaihoz létrehozunk egy-egy üres nyitvatartást
			data.regular_days = []
			for (const day of ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']) {

				data.regular_days.push(new Anvil.models.c_order.OpeningHours_Regular({
					// A hét napja
					day,

					// Nyitvatartási rend a hét adott napján
					open: null,
					close: null,
					closed: 0,
					web_open: null,
					web_close: null,
					web_closed: 0
				}))
			}
		} else [
			// Ha van adat, akkor azokat betöltjük, példányosítjuk
			data.regular_days = data.regular_days.map(r => new Anvil.models.c_order.OpeningHours_Regular(r))
		]

		// Rendhagyó nyitvatartások
		if (!Array.isArray(data.irregular_days)) data.irregular_days = []
		data.irregular_days = data.irregular_days.map(r => new Anvil.models.c_order.OpeningHours_Irregular(r))

		return this._proxy
	}

	async commit () {

		// Validate
		if (!this.validate())
			throw new Error('Kérjük ellenőrizze a megadott adatokat.')

		// Normál nyitvatartások validálása
		for (const regular_day of this._data.regular_days) {
			if (!regular_day.record.validate()) {
				throw new Error('Kérjük ellenőrizze a megadott adatokat.')
			}
		}

		// Rendhagyó nyitvatartások validálása
		for (const irregular_day of this._data.irregular_days) {
			if (!irregular_day.record.validate()) {
				throw new Error('Kérjük ellenőrizze a megadott adatokat.')
			}
		}

		// Update record
		await Anvil.models.c_order.Sync.pushOpeningHours(Anvil.settings.sync_storage_id, this._data)
	}
}
